<template>
  <div class="md-table-pagination">
    <button type="button" class="md-button md-icon-button md-theme-default" v-if="!hideFirstEndButtons"
            @click="onClickFirstPage"
            :disabled="isInFirstPage || disabled"
    >
      <div class="md-ripple">
        <div class="md-button-content"><i class="md-icon md-icon-font md-theme-default">first_page</i></div>
      </div>
    </button>

    <button type="button" class="md-button md-icon-button md-theme-default"
            @click="onClickPreviousPage"
            :disabled="isInFirstPage || disabled"
    >
      <div class="md-ripple">
        <div class="md-button-content"><i class="md-icon md-icon-font md-theme-default">chevron_left</i></div>
      </div>
    </button>

    <div v-for="page in pages" class="pagination-item">
      <button type="button" class="md-button md-icon-button md-theme-default"
              @click="onClickPage(page.name)"
              :disabled="page.isDisabled || disabled"
              :class="{ active: isPageActive(page.name) }"
      >
        <div class="md-ripple">
          <div class="md-button-content">{{ page.name }}</div>
        </div>
      </button>
    </div>

    <button type="button" class="md-button md-icon-button md-theme-default"
            @click="onClickNextPage"
            :disabled="isInLastPage || disabled"
    >
      <div class="md-ripple">
        <div class="md-button-content"><i class="md-icon md-icon-font md-theme-default">chevron_right</i></div>
      </div>
    </button>

    <button type="button" class="md-button md-icon-button md-theme-default" v-if="!hideFirstEndButtons"
            @click="onClickLastPage"
            :disabled="isInLastPage || disabled"
    >
      <div class="md-ripple">
        <div class="md-button-content"><i class="md-icon md-icon-font md-theme-default">last_page</i></div>
      </div>
    </button>
  </div>
</template>

<script>
  export default {
    name    : "Pagination",
    props   : {
      maxVisibleButtons  : {
        type    : Number,
        required: false,
        default : 3
      },
      hideFirstEndButtons: {
        type    : Boolean,
        required: false,
        default : false
      },
      total              : {
        type    : [Number, String],
        required: true
      },
      perPage            : {
        type    : [Number, String],
        required: true
      },
      currentPage        : {
        type    : [Number, String],
        required: true
      },
      disabled           : {
        type    : Boolean,
        required: false,
        default : false
      },
    },
    data    : function () {
      return {
        totalPages: 0,
      };
    },
    mounted : function () {
      this.totalPages = Math.ceil(this.total / this.perPage);
    },
    computed: {
      startPage() {
        if (this.currentPage === 1) {
          return 1;
        }
        let startPage = 1;
        if (this.currentPage === this.totalPages) {
          startPage = this.totalPages - this.maxVisibleButtons + 1;
          return startPage > 1 ? startPage : 1;
        }
        startPage = Math.max(1, this.currentPage - Math.floor(this.maxVisibleButtons / 2));
        if (Math.min(startPage + this.maxVisibleButtons - 1, this.totalPages) === this.totalPages) {
          startPage = this.totalPages - this.maxVisibleButtons + 1;
          return startPage > 1 ? startPage : 1;
        }
        return startPage;
      },
      endPage() {
        return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
      },
      pages() {
        const range = [];
        for (let i = this.startPage; i <= this.endPage; i += 1) {
          range.push({
            name      : i,
            isDisabled: i === this.currentPage
          });
        }
        return range;
      },
      isInFirstPage() {
        return this.currentPage === 1;
      },
      isInLastPage() {
        return this.currentPage === this.totalPages;
      },
    },
    methods : {
      onClickFirstPage() {
        this.$emit('pagechanged', 1);
      },
      onClickPreviousPage() {
        this.$emit('pagechanged', this.currentPage - 1);
      },
      onClickPage(page) {
        this.$emit('pagechanged', page);
      },
      onClickNextPage() {
        this.$emit('pagechanged', this.currentPage + 1);
      },
      onClickLastPage() {
        this.$emit('pagechanged', this.totalPages);
      },
      isPageActive(page) {
        return this.currentPage === page;
      },
    }
  }
</script>

<style lang="scss" scoped>
  .pagination {
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: .25rem;
  }

  .pagination-item {
    font-size: .9rem;
    color: #212529;
    background-color: transparent;
    border: 0;
    outline: 0;
  }

  .active {
    background-color: #4285f4;
    color: #ffffff !important;
  }
</style>
